import React, { Component } from "react";
import {
  Box,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select
} from "@material-ui/core";
import PropTypes from "prop-types";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { withAlert } from "react-alert";
import ClassService from "../../services/ClassService";
import BackButton from "../../components/BackButton";
import Group from "../../waybee-ui/Group";
import Heading from "../../waybee-ui/Heading";
import ReportDialog from "./components/ReportDialog";
import TableGrid from "../../waybee-ui/TableGrid";

const LoadContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: 32px 8px;
`;

class Reports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      courses: [],
      filter: {},
      loadingFilters: false,
      loadingReports: false,
      openDialog: false,
      reports: [],
      selectedReport: {}
    };
  }

  componentDidMount() {
    this.getCourses();
  }

  getCourses = async () => {
    const { match, alert } = this.props;

    this.setState({ loadingFilters: true });

    const classId = match.params.id;
    try {
      const disciplines = await ClassService.getDisciplines(classId);
      this.setState({ courses: disciplines });
      if (disciplines && disciplines.length) {
        this.setFilter("course", disciplines[0]);
        await this.getReports(disciplines[0].idTurmaDisc);
      }
    } catch (e) {
      console.error(e);
      alert.show("Ocorreu um erro ao buscar as disciplinas", { title: "Erro" });
    } finally {
      this.setState({ loadingFilters: false });
    }
  };

  getReports = async idTurmaDisc => {
    try {
      const { match } = this.props;
      const codTurma = match.params.id;

      this.setState({ loadingReports: true });
      const reports = await ClassService.getReports(idTurmaDisc, codTurma);
      this.setState({ reports });
    } catch (e) {
      const { alert } = this.props;
      alert.show(`Erro ao buscar os relatórios`, { title: "Erro" });
      throw e;
    } finally {
      this.setState({ loadingReports: false });
    }
  };

  onSelectItem = async report => {
    this.setState({ openDialog: true, selectedReport: report });
  };

  setFilter(field, value) {
    const { filter } = this.state;
    this.setState({
      filter: {
        ...filter,
        [field]: value
      }
    });
  }

  changeCourse = e => {
    this.setFilter("course", e.target.value);
    this.getReports(e.target.value.idTurmaDisc);
  };

  render() {
    const { history } = this.props;
    const {
      loadingFilters,
      loadingReports,
      courses,
      filter,
      reports,
      selectedReport,
      openDialog
    } = this.state;
    const { className, size } = this.props;

    return (
      <Grid container spacing={2}>
        <BackButton onClick={history.goBack} />
        {loadingFilters ? (
          <LoadContainer>
            <CircularProgress />
          </LoadContainer>
        ) : (
          <Grid item xs={12}>
            <Group>
              <Box pb={4} pt={2}>
                <Heading level={1} icon="insert_chart" gutterBottom>
                  Relatórios
                </Heading>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="filter-course-label">Disciplina</InputLabel>
                    <Select
                      fullWidth
                      labelId="filter-course-label"
                      value={filter.course}
                      onChange={this.changeCourse}
                    >
                      {courses.map(course => (
                        <MenuItem value={course}>{course.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Box>
              {loadingReports ? (
                <LoadContainer>
                  <CircularProgress />
                </LoadContainer>
              ) : (
                <TableGrid className={className}>
                  {reports.map(report => {
                    return (
                      <TableGrid.Row
                        key={report.id}
                        reportButton
                        button
                        onClick={() => this.onSelectItem(report)}
                      >
                        <TableGrid.Title
                          {...(size === "compact"
                            ? {
                                xs: 12
                              }
                            : {
                                xs: 12,
                                sm: 4
                              })}
                        >
                          <Box
                            {...(size === "compact" ? { ml: 1, mt: 1 } : {})}
                          >
                            {report.name}
                          </Box>
                        </TableGrid.Title>
                        <TableGrid.Text
                          {...(size === "compact"
                            ? {
                                xs: 12
                              }
                            : {
                                xs: 12,
                                sm: 4
                              })}
                        />
                      </TableGrid.Row>
                    );
                  })}
                </TableGrid>
              )}
            </Group>
          </Grid>
        )}
        {openDialog && (
          <ReportDialog
            open={openDialog}
            report={selectedReport}
            onClose={() =>
              this.setState({ openDialog: false, selectedReport: null })}
          />
        )}
      </Grid>
    );
  }
}

Reports.defaultProps = {
  className: "",
  size: "normal"
};

Reports.propTypes = {
  alert: PropTypes.shape({
    show: PropTypes.func
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.any
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.any
    })
  }).isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(["compact", "normal"])
};

export default withAlert()(withRouter(Reports));
